import React from 'react'

export const ScrollToTop = ({ children, location }) => {
  // Weirdness with Reach-router was stopping scroll to top
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname])
  return <div className={"full-size"}>{ children} </div>
};